import React from 'react';
import { Typography } from 'antd';
import { FileTextOutlined, UserOutlined, ShoppingOutlined } from '@ant-design/icons';

const PurchaseVerificationPrint = ({ purchaser, lead }) => {
  console.log(lead);
  const renderAnalyticsInfo = (analytics) => {
    if (!analytics) return null;

    const deviceInfo = [
      { label: 'Device Type', value: analytics.device_type },
      // { label: 'Device Name', value: analytics.device_name },
      { label: 'Platform', value: analytics.platform },
      { label: 'Platform Version', value: analytics.platform_version },
      { label: 'Browser', value: analytics.browser },
      { label: 'Browser Version', value: analytics.browser_version },
      { label: 'User Agent', value: analytics.user_agent },
      { label: 'Referer', value: analytics.referer },
      { label: 'IP Address', value: analytics.ip_address },
      { label: 'Created At', value: new Date(purchaser.purchase_date).toLocaleDateString() }
    ];

    const deviceFlags = [
      { label: 'Mobile', value: analytics.is_mobile, type: 'mobile' },
      { label: 'Tablet', value: analytics.is_tablet, type: 'tablet' },
      { label: 'Desktop', value: analytics.is_desktop, type: 'desktop' },
      { label: 'Robot', value: analytics.is_robot, type: 'robot' }
    ];

    return (
      <div className="section">
        <Typography.Title level={5}>
          <ShoppingOutlined style={{ marginRight: 4 }} />
          Analytics Information
        </Typography.Title>
        <div style={{ marginBottom: 12 }}>
          <div className="device-flags">
            {deviceFlags.map((flag, index) => (
              flag.value && (
                <span key={index} className={`device-flag ${flag.type}`}>
                  {flag.label}
                </span>
              )
            ))}
          </div>
        </div>
        <div className="info-grid">
          {deviceInfo.map((info, index) => (
            <div key={index} className="info-item">
              <div className="label">{info.label}</div>
              <div className="value" style={{ 
                fontSize: info.label === 'User Agent' || info.label === 'Referer' ? '11px' : '12px'
              }}>
                {info.value || '-'}
              </div>
            </div>
          ))}
        </div>
        {/* {analytics.additional_data && (
          <div style={{ marginTop: 12 }}>
            <div className="label">Additional Data</div>
            <div className="additional-data">
              {JSON.stringify(analytics.additional_data, null, 2)}
            </div>
          </div>
        )} */}
      </div>
    );
  };

  return (
    <>
      <div className="header">
        <Typography.Title level={4}>Lead Purchase Verification</Typography.Title>
        <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
          This document serves as official proof of lead purchase and ownership
        </Typography.Text>
        <div className="verification-stamp" />
      </div>

      <div className="section">
        <Typography.Title level={5}>
          <FileTextOutlined style={{ marginRight: 4 }} />
          Lead Information
        </Typography.Title>
        <div className="info-grid">
          <div className="info-item">
            <div className="label">Lead Name</div>
            <div className="value">{lead?.first_name} {lead?.last_name}</div>
          </div>
          <div className="info-item">
            <div className="label">Lead Price</div>
            <div className="value">${purchaser.amount}</div>
          </div>
          <div className="info-item">
            <div className="label">Purchase Date</div>
            <div className="value">
              {new Date(purchaser.purchase_date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="section">
        <Typography.Title level={5}>
          <UserOutlined style={{ marginRight: 4 }} />
          Purchaser Information
        </Typography.Title>
        <div className="info-grid">
          <div className="info-item">
            <div className="label">Name</div>
            <div className="value">{purchaser.name}</div>
          </div>
          <div className="info-item">
            <div className="label">Email</div>
            <div className="value">{purchaser.email}</div>
          </div>
          <div className="info-item">
            <div className="label">Phone</div>
            <div className="value">{purchaser.phone}</div>
          </div>
          <div className="info-item">
            <div className="label">Transaction ID</div>
            <div className="value">{purchaser.transaction_id}</div>
          </div>
        </div>
      </div>

      {purchaser.analytics && renderAnalyticsInfo(purchaser.analytics)}

      <div className="footer" style={{marginTop: 50}}>
        <div className="signature-line">
          <Typography.Text style={{ fontSize: '12px' }}>Authorized Signature</Typography.Text>
        </div>
        <Typography.Text type="secondary" style={{ fontSize: '11px' }}>
          This document was generated on {new Date().toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
          })}
        </Typography.Text>
        <div style={{ marginTop: 4 }}>
          <Typography.Text type="secondary" style={{ fontSize: '10px' }}>
            This is an official verification document. For verification, please contact support.
          </Typography.Text>
        </div>
      </div>
    </>
  );
};

export default PurchaseVerificationPrint; 